import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-1993" data-mp="9wsbskew6ft4">
      <About data-id="element-1994" data-mp="9w0gzbt4cm3w" />
    </main>;
}